<template>
    <a v-if="$attrs?.href || false" :class="classes" v-bind="$attrs">
        <span v-if="icon" :class="prefixClass + ' ' + icon"></span><slot></slot>
    </a>
    <router-link v-else-if="$attrs.to || false" :class="classes" v-bind="$attrs">
        <span v-if="icon" :class="prefixClass + ' ' + icon"></span><slot></slot>
    </router-link>
    <button v-else type="button" :class="[...classes, fontStyle]" v-bind="$attrs">
        <span v-if="icon" :class="prefixClass + ' ' + icon + ' ' + (iconSize ? iconSize : '')"></span><slot></slot>
    </button>
</template>

<script>
export default {
    computed: {
        classes() {
            return [
                'inline-flex items-center gap-1 rounded-lg p-3 text-sm leading-4 shadow-sm focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 border',
                (this.$attrs.disabled ? 'cursor-not-allowed' : 'cursor-pointer'),
                this.getColor
            ]
        },
        getColor() {
            if(this.$attrs.disabled) return 'bg-bhav-cool-gray-50 text-bhav-blue-200 border-transparent';
            switch(this.color) {
                case 'green' :
                case 'primary' :
                    return 'bg-bhav-green-600 hover:bg-bhav-green-500 text-white border-transparent';
                case 'gray' :
                case 'secondary' :
                    return 'bg-bhav-cool-gray-50 hover:bg-bhav-blue-50 text-bhav-blue-500 hover:border-bhav-blue-500 border-transparent hover:border-transparent whitespace-nowrap';
                case 'blue' :
                case 'tertiary' :
                    return 'bg-bhav-blue-500 hover:bg-bhav-blue-400 text-white border-transparent';
                case 'red' :
                    return 'bg-bhav-red-100 hover:bg-bhav-red-200 text-bhav-red-500 hover:text-bhav-red-600  border-transparent';
                case 'sage' :
                case 'quaternary' :
                    return 'bg-sage-600 hover:bg-sage-500 text-white border-transparent';
                case 'secondary-bg-white' :
                    return 'bg-white hover:bg-bhav-blue-50 text-bhav-blue-500 hover:border-bhav-blue-500 border-transparent hover:border-transparent whitespace-nowrap';
                default :
                    return ''
            }
        }
    },
    props: {
        icon: {
            type: [Boolean, String],
            default: false,
            required: false
        },
        iconSize: {
            type: [Boolean, String],
            default: false,
            required: false
        },
        fontStyle: {
            type: String,
            default: 'font-normal',
            required: false
        },
        prefixClass: {
            type: String,
            default: 'far',
            required: false
        },
        color: {
            type: String,
            default: null
        }
    }
}
</script>
